import React from "react";
import { motion } from "framer-motion";
import { TID } from "../../lib/testIds";

export const FilterBar = ({ categories, active, onChange, counts }) => {
  return (
    <div className="w-full">
      <div className="flex items-center gap-3 overflow-x-auto hide-scrollbar pb-2 -mx-2 px-2 md:justify-start">
        {categories.map((cat) => {
          const isActive = active === cat;
          const count = counts?.[cat] ?? 0;
          return (
            <motion.button
              key={cat}
              layout
              data-testid={TID.gallery.filter(cat)}
              onClick={() => onChange(cat)}
              whileTap={{ scale: 0.96 }}
              className={`relative shrink-0 inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium border transition-colors whitespace-nowrap ${
                isActive
                  ? "bg-[#0A2540] text-white border-[#0A2540]"
                  : "bg-white text-slate-700 border-slate-200 hover:border-slate-300 hover:bg-slate-50"
              }`}
            >
              <span>{cat}</span>
              <span
                className={`text-[10px] font-mono px-1.5 py-0.5 rounded-full ${
                  isActive
                    ? "bg-white/20 text-white"
                    : "bg-slate-100 text-slate-500"
                }`}
              >
                {String(count).padStart(2, "0")}
              </span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};
